import DateTime from "utils/DateTime";

const COMPLETED_LABEL = "completed";

const SCHEDULED_STATUS_TYPES = {
  FULLY_SCHEDULED: "fully_scheduled",
  OVERSCHEDULED: "overscheduled",
  UNDERSCHEDULED: "underscheduled",
};

// @keep_work_order_statuses_in_sync
const STATUS_TYPES = {
  BOOKED: "booked",
  CANCELLED: "cancelled",
  CLOSED: "closed",
  OPEN: "open",
};

const WorkOrder = {
  COMPLETED_LABEL,
  cardStatus,
  getFirstCustomFieldValue,
  hasNonZeroProductionRate,
  isCancelled,
  isCompleted,
  isFullyProduced,
  isFullyScheduled,
  isMissingData,
  isOverdue,
  isOverscheduled,
  isScheduledCompletedOrCancelled,
  SCHEDULED_STATUS_TYPES,
  STATUS_TYPES,
};

function cardStatus(workOrder) {
  if (isCancelled(workOrder)) return STATUS_TYPES.CANCELLED;
  if (isCompleted(workOrder)) return COMPLETED_LABEL;
  if (isMissingData(workOrder)) return SCHEDULED_STATUS_TYPES.UNDERSCHEDULED;

  return workOrder.scheduledStatus;
}

function isCompleted({ completed }) {
  return completed;
}

function isCancelled({ status }) {
  return STATUS_TYPES.CANCELLED === status;
}

function isMissingData({ missingData }) {
  return missingData;
}

function isFullyScheduled({ scheduledStatus }) {
  return SCHEDULED_STATUS_TYPES.FULLY_SCHEDULED === scheduledStatus;
}

function isOverscheduled({ scheduledStatus }) {
  return SCHEDULED_STATUS_TYPES.OVERSCHEDULED === scheduledStatus;
}

function isOverdue({ due }) {
  if (!due) return false;

  return DateTime.endOfDay(due) < DateTime.now();
}

function isFullyProduced({ producedQuantity, quantity }) {
  return quantity > 0 && producedQuantity >= quantity;
}

function isScheduledCompletedOrCancelled(workOrder) {
  return isFullyScheduled(workOrder) || isCompleted(workOrder) || isCancelled(workOrder);
}

function hasNonZeroProductionRate(workOrder) {
  return workOrder.standardProductionRate > 0 && workOrder.performance > 0;
}

function getFirstCustomFieldValue(workOrder) {
  const firstSelection = workOrder?.customWorkOrderFieldSelections?.[0];
  if (!firstSelection?.customWorkOrderFieldValue) return null;

  return {
    description: firstSelection.customWorkOrderFieldValue.description,
    indicator: firstSelection.customWorkOrderFieldValue.indicator,
  };
}

export default WorkOrder;
